export const environment = {
  GRAPHQL_URI: 'https://app-asae-stage-graphql-bqd9fcd4hsbxb0a8.eastus2-01.azurewebsites.net/',
  GRAPHQL_WS_URI: 'wss://app-asae-stage-graphql-bqd9fcd4hsbxb0a8.eastus2-01.azurewebsites.net/',
  REDIRECT_URI: 'https://bridge-asae-stage.soundpost.ai',
  CLIENT_ID: '99ff73ef-9ce3-4092-ac30-cddc809258a1',
  TENANT_ID: 'ff10ade7-5d03-40a9-be28-cb7ab99670b1',
  CLIENT_AUTHORITY: 'https://login.microsoftonline.com/organizations',
  AUTH_TYPE: 'msal' as const,
  NODE_ENV: 'production',
  AUTOSAVE_DEBOUNCE_MS: 1200,
  SEARCH_DEBOUNCE_MS: 800,
  MIN_SEARCH_LENGTH: 3,
  MJ_CORE_SCHEMA_NAME: '__mj',
  production: true,
  APPLICATION_NAME: 'SoundPost Bridge',
  APPLICATION_INSTANCE: 'STAGE',
  AUTH0_DOMAIN: 'dev-pb3zdwv3lfh86612.us.auth0.com',
  AUTH0_CLIENTID: 'mSEjeZSSbHoRqWPoMQ438k0r1FtJQQqy',
}